/* eslint-disable */
const html = new RegExp('<[a-z][\\s\\S]*>')
/* eslint-enable */

export default function inputGeneralValidation(value) {
  return !html.test(value)
}
